import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServicioDemandaInducidaService } from '../../services/servicio-demanda-inducida.service';
import { EntidadEmpresarialEntity, ServicioEntidadService } from '../../services/servicio-entidad.service';
import { ImagesService } from '../../services/utils/images.service';

@Component({
  selector: 'app-reporte-demanda-inducida',
  templateUrl: './reporte-demanda-inducida.component.html',
  styleUrls: ['./reporte-demanda-inducida.component.css']
})
export class ReporteDemandaInducidaComponent implements OnInit {

  public code: string = '';
  public uncoSede: number = 0;
  public uncoHistoria: number = 0;
  public logo: string = '';
  public fecha: Date;
  public user: string = '';
  public entidadEmpresarial: EntidadEmpresarialEntity;

  public demanda: any;
  public demandas: any[];
  public finalidadGroup: {unco: number, finalidad: string, demandas: any[]}[];

  constructor(private servicioEntidad: ServicioEntidadService,
              private servicioImagenes: ImagesService,
              private activatedRoute: ActivatedRoute,
              private servicioDemanda: ServicioDemandaInducidaService) {
    this.activatedRoute.params.subscribe((param: any) => {
      this.code = String(param['codigoBaseDatos']);
      this.uncoSede = Number(param['uncoSede']);
      this.uncoHistoria = Number(param['uncoHistoria']);
      this.user = String(param['user']);
    });
  }

  ngOnInit() {
    this.getEntidadEmpresarial();
    this.getLogo();
    this.getDemandasInducidas();
    this.fecha = new Date();
  }

  private async getEntidadEmpresarial() {
    try {
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.code, this.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {
          this.entidadEmpresarial = data[0];
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteDemandaInducidaComponent.getEntidadEmpresarial()', err);
      });
    } catch (e) {
      console.error('Catch ReporteDemandaInducidaComponent.getEntidadEmpresarial()', e);
    }
  }

  private async getLogo() {
    try {
      this.logo = '';
      const response = await this.servicioImagenes.getLogo(this.code);
      response.subscribe((data: any) => {
        this.logo = data.source;
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicaComponent.getLogo()', err);
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicaComponent.getLogo()', e);
    }
  }

  private async getDemandasInducidas() {
    try{
      const response = await this.servicioDemanda.getDemandasInducidas(this.code, this.uncoHistoria);
      response.subscribe((data: any[]) => {
        if (data && data.length > 0) {
          this.demanda = data[0];
          this.demandas = data;
          this.finalidadGroup = [];
          if (this.demandas && this.demandas.length > 0) {
            this.demandas.forEach((demanda: any) => {
              const uncoFinalidad = demanda.uncoFinalidadConsulta;
              const finalidad = demanda.finalidadConsulta;

              const index = this.finalidadGroup.findIndex((fg: any) => fg.unco == uncoFinalidad);
              if (index == -1) {
                this.finalidadGroup.push({
                  unco : uncoFinalidad,
                  finalidad : finalidad,
                  demandas : [ demanda ]
                })
              } else {
                this.finalidadGroup[index].demandas.push(demanda);
              }

            })
          }
        }
        
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteDemandaInducidaComponent.getDemandasInducidas()', err);
      });
    } catch (e) {
      console.error('Catch ReporteDemandaInducidaComponent.getDemandasInducidas()', e);
    }
  }

}
